<template>
  <div class="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]"
       @click.self="closeModal"
  >
    <div class="bg-white rounded-md w-4/5 max-w-4xl max-h-[80vh] flex flex-col">
      <div class="px-5 py-4 border-b border-gray-200 flex justify-between items-center">
        <h3 class="text-lg font-medium">{{ title }}</h3>
        <button class="bg-transparent border-none text-2xl cursor-pointer focus:outline-none"
                @click="closeModal"
        >
          &times;
        </button>
      </div>
      <div class="p-5 overflow-y-auto max-h-[calc(80vh-70px)]">
        <div v-if="jsonData" class="w-full">
          <pre v-if="isValidJson"
               class="bg-gray-100 p-4 rounded-md whitespace-pre-wrap break-words font-mono"
          >{{ formattedJson }}
          </pre>
          <div v-else class="text-gray-500 italic text-center py-5">Invalid JSON data</div>
        </div>
        <div v-else class="text-gray-500 italic text-center py-5">No data available</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JSONModal',
  props: {
    jsonData: {
      type: [Object, Array, String],
      default: null
    },
    title: {
      type: String,
      default: 'JSON Data'
    }
  },
  computed: {
    isValidJson() {
      return this.jsonData !== null && this.jsonData !== undefined;
    },
    formattedJson() {
      if (!this.isValidJson) {
        return '';
      }

      try {
        let json;
        // If jsonData is already an object/array, stringify it
        if (typeof this.jsonData === 'object') {
          json = this.jsonData;
        }
        // If it's a string, try to parse it
        else if (typeof this.jsonData === 'string') {
          json = JSON.parse(this.jsonData);
        } else {
          return String(this.jsonData);
        }

        // Custom formatting to remove first level indentation and outer braces/brackets
        let jsonString = JSON.stringify(json, null, 2);
        // Remove first and last line (the outer brackets/braces)
        let lines = jsonString.split('\n');
        if (lines.length > 2) {
          lines = lines.slice(1, -1);
          // Remove first level indentation (2 spaces)
          lines = lines.map(line => line.startsWith('  ') ? line.substring(2) : line);
        }
        return lines.join('\n');
      } catch (e) {
        return String(this.jsonData);
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  },
};
</script>
